/** Wallet that sees Admin nav and extra diagnostics (matches `Admin.tsx`). */
const ENV_ADMIN = (import.meta.env.VITE_ADMIN_WALLET as string | undefined)?.trim().toLowerCase();

export const ADMIN_WALLET_LOWER =
  ENV_ADMIN && /^0x[a-f0-9]{40}$/.test(ENV_ADMIN)
    ? ENV_ADMIN
    : '0x319d1291bc4fc5948af22c7cc0084483d8b1055f';

export function isAdminWallet(connectedAddress: string | undefined): boolean {
  return Boolean(connectedAddress && connectedAddress.toLowerCase() === ADMIN_WALLET_LOWER);
}
